(function () {
  function init303ProductTabs(root) {
    var scope = root || document;

    var sections = scope.querySelectorAll('.product-main-info-section');

    sections.forEach(function (section) {
      if (section.querySelector('.product-tabs-303')) return;

      var description = section.querySelector('.product-tab-description-303');
      var accordionSources = Array.from(
        section.querySelectorAll('.product-tab-source-303')
      );

      if (!description || !accordionSources.length) return;

      var tabs = document.createElement('div');
      tabs.className = 'product-tabs-303';

      var nav = document.createElement('div');
      nav.className = 'product-tabs-303__nav';
      nav.setAttribute('role', 'tablist');

      var panels = document.createElement('div');
      panels.className = 'product-tabs-303__panels';

      var lang = document.documentElement.lang || '';
      var descriptionTitle =
        lang.toLowerCase().indexOf('pl') === 0 ? 'Opis' : 'Description';

      var items = [
        {
          title: descriptionTitle,
          html: description.innerHTML
        }
      ];

      accordionSources.forEach(function (source) {
        var sourcePanel = source.querySelector('.accordion-panel');

        if (!sourcePanel) return;

        items.push({
          title: source.getAttribute('data-tab-title') || '',
          html: sourcePanel.innerHTML
        });
      });

      items.forEach(function (item, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-tabs-303__button';
        button.textContent = item.title;
        button.setAttribute('role', 'tab');
        button.setAttribute(
          'aria-selected',
          index === 0 ? 'true' : 'false'
        );

        var panel = document.createElement('div');
        panel.className = 'product-tabs-303__panel';
        panel.setAttribute('role', 'tabpanel');
        panel.innerHTML = item.html;

        if (index === 0) {
          button.classList.add('is-active');
          panel.classList.add('is-active');
        }

        button.addEventListener('click', function () {
          nav
            .querySelectorAll('.product-tabs-303__button')
            .forEach(function (btn) {
              btn.classList.remove('is-active');
              btn.setAttribute('aria-selected', 'false');
            });

          panels
            .querySelectorAll('.product-tabs-303__panel')
            .forEach(function (pnl) {
              pnl.classList.remove('is-active');
            });

          button.classList.add('is-active');
          button.setAttribute('aria-selected', 'true');
          panel.classList.add('is-active');
        });

        nav.appendChild(button);
        panels.appendChild(panel);
      });

      tabs.appendChild(nav);
      tabs.appendChild(panels);

      description.parentNode.insertBefore(tabs, description);

      description.style.display = 'none';

      accordionSources.forEach(function (source) {
        source.style.display = 'none';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init303ProductTabs(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init303ProductTabs(event.target);
  });
})();